import React from 'react';
import PropTypes from 'prop-types';
import Button from '../Button';
import { getTranslation } from '../../providers/TranslationProvider';

import './AnnouncementCard.scss';

const AnnouncementCard = ({
  imageUrl, header, iconUrl, subheader, tileTermText, onClickCTA,
}) => {
  const logoAltText = getTranslation({ translationKey: 'announcement_logo', fallback: 'Announcement logo' });
  const iconAltText = iconUrl ? getTranslation({ translationKey: 'announcement_icon', fallback: 'Announcement icon' }) : '';

  return (
    <div className="AnnouncementCard">
      <Button variant="secondary" className="AnnouncementCard-link" onClick={onClickCTA} aria-label={header}>
        <img className="AnnouncementCard-logo" src={imageUrl} alt={logoAltText} />

        <div className="AnnouncementCard-content">
          {subheader && <div className="AnnouncementCard-subtitle">{subheader}</div>}
          {iconUrl && (
          <div className="AnnouncementCard-icon-container">
            <img className="AnnouncementCard-icon" src={iconUrl} alt={iconAltText} />
          </div>
          )}
          <div className="AnnouncementCard-header">{header}</div>
          {tileTermText && <div className="AnnouncementCard-terms">{tileTermText}</div>}
        </div>
      </Button>
    </div>
  );
};

AnnouncementCard.propTypes = {
  imageUrl: PropTypes.string.isRequired,
  iconUrl: PropTypes.string,
  header: PropTypes.string.isRequired,
  subheader: PropTypes.string,
  tileTermText: PropTypes.string,
  onClickCTA: PropTypes.func.isRequired,
};

AnnouncementCard.defaultProps = {
  iconUrl: null,
  subheader: null,
  tileTermText: null,
};

export default AnnouncementCard;
